export default __webpack_public_path__ + "static/bigO-735fdb9061be5d9683b6f827bc1c8cff.jpg";